import * as React from "react";
import Styles from "./textfield.module.scss";
// import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@material-ui/core";
// import MobileDatePicker from "@mui/lab/MobileDatePicker";
// import { useDispatch } from "react-redux";

interface TextInputProps {
  id?: string;
  inputLabel: string;
  inputType?: string;
  inputShrink?: boolean;
  notRequired?: boolean;
  readOnly?: boolean;
  InputHelper?: string;
  inputSelect?: boolean;
  inputOption?: string[] | number[];
  multiline?: boolean;
  inputName: string;
  autoComplete?: string;
  rows?: number;
  style?: React.CSSProperties;
  inputValue?: string | number;
  handleChange?: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  >;
}

const PrimaryTextInput = ({
  inputLabel,
  id = "standard",
  inputType,
  notRequired,
  InputHelper,
  inputShrink,
  readOnly = false,
  inputSelect = false,
  inputOption,
  multiline = false,
  inputName,
  autoComplete, // Add this line
  inputValue,
  style,
  rows,
  handleChange,
}: TextInputProps) => {
  // const dispatch = useDispatch();
  // interface State {
  //   amount: string;
  //   password: string;
  //   weight: string;
  //   weightRange: string;
  //   showPassword: boolean;
  // }

  const useStyles = makeStyles({
    root: { color: "orange !important" },
    cssFocused: {
      fontFamily: "Kumbh Sans",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "12px !important",
      lineHeight: "16px",
      color: "#DDE1FD !important",
      textTransform: "uppercase",
    },
    cssLabel: {
      color: "rgba(255, 255, 255, 0.81)",
      backgroundColor: "white",
      // border: "1px solid red",
    },
    cssOutlinedInput: {
      "&$cssFocused $notchedOutline": {
        borderColor: `#AAAAAA !important`,
        borderWidth: "1px !important",
      },
    },
    notchedOutline: {
      borderColor: "#AAAAAA !important",
    },
    helperText: {
      fontFamily: "Kumbh Sans !important",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "15px",
      color: "#DDE1FD !important",
    },
  });
  const classes = useStyles();
  return (
    <TextField
      id={id}
      // label={inputLabel}
      onChange={handleChange}
      placeholder={inputLabel}
      select={inputSelect}
      style={style}
      required={notRequired ? false : true}
      classes={{ root: classes.root }}
      className={Styles.inputField}
      name={inputName}
      value={inputValue}
      disabled={readOnly}
      autoComplete={autoComplete}
      variant="outlined"
      multiline={multiline}
      type={inputType ? inputType : ""}
      rows={rows}
      InputLabelProps={{
        classes: {
          root: classes.cssLabel,
          focused: classes.cssFocused,
        },
        shrink: inputShrink,
      }}
      InputProps={{
        classes: {
          root: classes.cssOutlinedInput,
          focused: classes.cssFocused,
          notchedOutline: classes.notchedOutline,
        },
      }}
    >
      {inputOption?.map((option, index) => (
        <option value={option} key={index}>
          {option}
        </option>
      ))}
    </TextField>
  );
};

export default PrimaryTextInput;
